<template>
    <div>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="3">
                <b-form-group label="Дата с:" label-cols-md="3" class="bolded-label">
                    <date-picker
                        placeholder="Выберите дату"
                        v-model="dateFromForInput"
                        format="DD/MM/YYYY"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <b-form-group label="Дата по:" label-cols-md="3" class="bolded-label">
                    <date-picker
                        placeholder="Выберите дату"
                        v-model="dateToForInput"
                        format="DD/MM/YYYY"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!---------------------регион------------------------->
                <b-form-group label="Регион (Область, город, район, село):" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать регион"
                        track-by="code"
                        label="text"
                        v-model="reg"
                        :options="listReg"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        @input="chgRegions"
                        ref="regionRef"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <!-------------Ед. измерения---------------------->
                <b-form-group label="Единица измерения:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать единицу измерения"
                        v-model="curUnit"
                        :options="unit"
                        :custom-label="unitLabel"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        class="w-150px"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="py-2 bb-row">
            <b-col cols="12" md="6">
                <!---------------------вид бюджета------------------------->
                <b-form-group label="Вид бюджета:" label-cols-md="3" class="bolded-label">
                    <multiselect
                        placeholder="Выбрать вид бюджета"
                        track-by="code"
                        label="name"
                        v-model="budget_type"
                        :options="list_budget_types"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        ref="budgetTypeRef"
                        @input="loadFin"
                    >
                    </multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
    <b-form-group
        label="Источник финансирования:"
        label-cols-md="3"
        class="bolded-label"
    >
        <multiselect
            placeholder="Выбрать источник финансирования"
            track-by="code"
            v-model="selectedFin"
            :options="listFin"
            :custom-label="finLabel"
            :searchable="true"
            :allow-empty="false"
            :show-labels="false"
        >
        </multiselect>
    </b-form-group>
</b-col>
        </b-row>
<!--        <b-row class="py-2 bb-row">-->
<!--            <b-button variant="success" :disabled="isLoad" @click="downloadRep">Скачать</b-button>-->
<!--        </b-row>-->
    </div>
</template>

<script>
import store from "../../../services/store";
import {Ax} from '@/utils';
import DatePicker from "vue2-datepicker";

export default {
    name: "treasury-form-534",
    components: { DatePicker },
    data() {
        return {
            obl: null,
            listReg: [],
            reg: null,
            dateFrom: null,
            dateFromForInput: null,
            dateTo: null,
            dateToForInput: null,
            // languages: ['Казахский', 'Русский'],
            // selectedLanguage: 'Русский',
            budget_type: null,
            list_budget_types: [],
            selectedFin: null,
            listFin: [],
            unit: ['tenge', 'thousand_tenge', 'million_tenge'],
            curUnit: 'tenge',
            isLoad: false,
        }
    },
    async mounted() {
        // сегодняшняя дата
        this.dateFromForInput = new Date();
        this.dateFrom = new Date().toLocaleDateString().split('.').reverse().join('-');

        // послд день текущего года
        this.dateToForInput = new Date(`${new Date().getFullYear()}-12-31`);
        this.dateTo = new Date().getFullYear() + '-12-31';
        await this.getObl();
    },
    methods: {
        unitLabel(key) {
            return this.$t(`modules.budget_execution_monitoring.treasury_forms.${key}`);
        },

        async getObl() {
            try {
                await fetch('/api-py/get-budget-obl/' + store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                        // this.reg = json.region;
                    });
                await this.loadRegions();
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        },

        async loadRegions() {
            try {
                this.listReg = [];
                this.reg = null;
                if (this.dateFrom.includes('/')) {
                    this.dateFrom = this.dateFrom.split('/').reverse().join('-')
                }
                if (this.dateTo.includes('/')) {
                    this.dateTo = this.dateTo.split('/').reverse().join('-')
                }
                const response = await fetch(`/api-py/get_kato_for_534/${this.obl}/${this.dateFrom}/${this.dateTo}/${this.usrId}`);
                this.listReg = await response.json();
                if (this.listReg && this.listReg.length > 0) {
                    this.reg = this.listReg[0];
                }

            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса регионов', error.toString());
            }

            await this.chgRegions();
        }, // справочник регионов

        async chgRegions() {
            if (this.reg && this.reg.code) {
                await this.loadBudjetTypes();
            }
        },

        async loadBudjetTypes() {
    try {
        this.list_budget_types = [];
        this.budget_type = null;
        this.listFin = [];
        this.selectedFin = null;

        if (this.reg) {
            const response = await fetch(
                `/api-py/get_type_bud_for_534/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.usrId}`
            );

            this.list_budget_types = await response.json();

            if (this.list_budget_types && this.list_budget_types.length > 0) {
                this.budget_type = this.list_budget_types[0];
                await this.loadFin();
            }
        }
    } catch (error) {
        this.makeToast(
            'danger',
            'Ошибка запроса loadBudjetTypes',
            error.toString()
        );
    }
},

async loadFin() {
    try {
        this.listFin = [];
        this.selectedFin = null;

        if (
            !this.dateFrom ||
            !this.dateTo ||
            !this.reg ||
            !this.reg.code ||
            !this.budget_type ||
            !this.budget_type.code
        ) {
            return;
        }

        const response = await fetch(
            `/api-py/get-fin-for-534/${this.dateFrom}/${this.dateTo}/${this.reg.code}/${this.budget_type.code}`
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        this.listFin = await response.json();

        if (this.listFin.length > 0) {
            this.selectedFin = this.listFin[0];
        }
    } catch (error) {
        this.listFin = [];
        this.selectedFin = null;

        this.makeToast(
            'danger',
            'Ошибка запроса источников финансирования',
            error.toString()
        );
    }
},

        finLabel(item) {
            if (!item) {
                return '';
            }

            const locale = this.$i18n.locale;
            let name = null;

            if (locale === 'kk' || locale === 'kz') {
                name = item.name_kk;
            } else {
                name = item.name_ru;
            }

            if (name) {
                return `${item.code} - ${name}`;
            }

            return item.code;
        },

        setNameLang(obj, codeName) {
            let txt = obj['name_' + this.$i18n.locale];
            if (txt === undefined) {
                txt = obj.name_ru;
            }
            if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                txt = obj[codeName] + ' - ' + txt;
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            return el;
        },

        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        },

        downloadRep() {
    try {
        if (!(this.selectedFin && this.selectedFin.code)) {
            this.makeToast(
                'danger',
                'Предупреждение',
                'Пожалуйста, выберите Источник финансирования'
            );
            this.$emit('onDownload', 0);
            return;
        }

        if (
            !(this.reg && this.reg.hasOwnProperty('code') && this.reg.code) ||
            !(this.budget_type && this.budget_type.hasOwnProperty('code') && this.budget_type.code) ||
            !(this.curUnit) ||
            !(this.dateFrom) ||
            !(this.dateTo)
        ) {
            this.makeToast(
                'danger',
                'Предупреждение',
                'Необходимо заполнить все обязательные фильтры!'
            );
            this.$emit('onDownload', 0);
            return;
        }

        this.makeToast(
            'info',
            this.$i18n.t('modules.execution.attention'),
            this.$i18n.t('modules.execution.treasury_forms_informative_message')
        );

        this.isLoad = true;

        const filter = {
            region: this.reg.code,
            unit: this.curUnit,
            locale: this.$i18n.locale,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            type_bud: this.budget_type.code,
            type_bud_name: this.budget_type.name,
            fin: this.selectedFin.code
        };

        Ax(
            {
                url: '/api-py/treasury-form-xls-rep-534',
                method: 'POST',
                responseType: 'blob',
                data: filter
            },
            (data) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', 'Форма 05-34.xlsx');

                this.$emit('onDownload', 100);
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.$emit('onDownload', 0);
                this.makeToast(
                    'danger',
                    'Ошибка запроса downloadRep()',
                    error.toString()
                );
            }
        );
    } catch (error) {
        console.log(error);
        this.makeToast(
            'danger',
            'Предупреждение',
            'Необходимо заполнить все обязательные фильтры!'
        );
        this.$emit('onDownload', 0);
    } finally {
        this.isLoad = false;
    }
},
    },
    watch: {
        async dateFromForInput() {
            this.dateFrom = `${this.dateFromForInput.getFullYear()}-${this.dateFromForInput.getMonth() + 1}-${this.dateFromForInput.getDate()}`
            await this.loadRegions();
        },
        async dateToForInput() {
            this.dateTo = `${this.dateToForInput.getFullYear()}-${this.dateToForInput.getMonth() + 1}-${this.dateToForInput.getDate()}`
            await this.loadRegions();
        }
    },
    computed: {
        usrId() {
            if (!store.state.user.sub) { return null; }
            return store.state.user.sub;
        }
    }
}
</script>

<style scoped>

</style>